import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/mobile/leaves_524x558.webp")